import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useCompanyManagerDashboardBubobumCounters } from '../../../graphql/company-manager-dashboard/hooks/useCompanyManagerDashboardBusinessUnitsAndBranchOfficesQueries'
import { showNotification } from '../../../components/custom_components/Notification/notification'
import { useDashboardStore } from '../DashboardStore'
import '../styles/dashboard-filters-area.less'
import DashboardPyramids from './DashboardPyramids'
import DashboardDistributions from './DashboardDistributions'
import DashboardFiltersAreaHeader from './DashboardFiltersAreaHeader'
import { FiltersTabs } from '../dasboardStoreTypes'

const DashboardFiltersArea: FC = () => {
  const { t } = useTranslation()
  const [selectedCompanyId, selectedDashboardRoles, setDistributionBubobumCounters, activeFiltersTab, setActiveFiltersTab] =
    useDashboardStore((state) => [
      state.selected.value,
      state.selectedDashboardRoles,
      state.setDistributionBubobumCounters,
      state.activeFiltersTab,
      state.setActiveFiltersTab,
    ])
  const { data, error } = useCompanyManagerDashboardBubobumCounters(selectedCompanyId, selectedDashboardRoles)

  useEffect(() => {
    const counters = data?.companyManagerDashboardBubobumCounters
    if (!counters) {
      return
    }
    setDistributionBubobumCounters({
      businessUnit: counters.businessUnit,
      buManagers: counters.buManagers,
      branchOffice: counters.branchOffice,
    })
    if (counters.branchOffice === 0 && activeFiltersTab === FiltersTabs.OFFICE) {
      setActiveFiltersTab(FiltersTabs.BUSINESS_UNIT)
    }
  }, [data, setDistributionBubobumCounters, setActiveFiltersTab, activeFiltersTab])

  useEffect(() => {
    if (!error) {
      return
    }
    showNotification({
      type: 'error',
      message: t('dashboard.companyManager.filtersArea.distributions.bubobumCountersQueryError.title'),
      description: t('dashboard.companyManager.filtersArea.distributions.bubobumCountersQueryError.description'),
    })
  }, [error, t])

  return (
    <div className="dashboard-filters-area">
      <DashboardFiltersAreaHeader />

      <div className="dashboard-filters-area__body">
        <DashboardDistributions />
        <DashboardPyramids />
      </div>
    </div>
  )
}

export default DashboardFiltersArea
